import { RcFile } from 'antd/es/upload';
import { UploadFile } from 'antd/lib';
import { UploadFileWithThumb } from 'models/file';

export const isImageFile = (file: File | RcFile | UploadFile | UploadFileWithThumb) => {
  return file.type?.startsWith('image');
};
